'use strict';

const Reflux = require('@muzzylane/reflux');

const ViewStateActions = require('../actions/ViewStateActions');

let viewName = null;

const ViewStateStore = Reflux.createStore({
    listenables: [ViewStateActions],
    init: function() {},

    getState: function() {
        return {
            viewName: viewName,
        };
    },

    emitStatus: function() {
        this.trigger(this.getState());
    },

    onUpdateViewNameCompleted: function(_viewName) {
        console.log('onUpdateViewNameCompleted:', _viewName);
        viewName = _viewName;
        this.emitStatus();

        setTimeout(() => {
            viewName = '';
            this.emitStatus();
        }, 500);
    },
});

module.exports = ViewStateStore;
